import { COLORS } from 'shared/constants/COLORS';
const { PASS_CIRCULAR_PROGRESS_BAR, WARNING_CIRCULAR_PROGRESS_BAR, ERROR_CIRCULAR_PROGRESS_BAR } = COLORS;

export const getCompletionColor = (completeness: number) => {
  const color = () => {
    if (completeness === 100) {
      return PASS_CIRCULAR_PROGRESS_BAR;
    } else if (completeness < 50) {
      return ERROR_CIRCULAR_PROGRESS_BAR;
    } else {
      return WARNING_CIRCULAR_PROGRESS_BAR;
    }
  };

  return color(); // Returning the result of the color function
};
